import React, { FC } from "react";

interface SwiftIbanTabProps {
  isSwift: boolean;
  setIsSwift: React.Dispatch<React.SetStateAction<boolean>>;
  isVerified: boolean;
}

const SwiftIbanTab: FC<SwiftIbanTabProps> = ({ isSwift, setIsSwift, isVerified }) => {
  return (
    <div className="w-full flex justify-center">
      <div className={`flex w-[360px] rounded-xl bg-gray-200 p-1`}>
        {/* SWIFT */}
        <button
          type="button"
          onClick={() => setIsSwift(true)}
          disabled={isVerified}
          className={`
            flex-1 py-2 text-sm font-semibold rounded-lg transition-all
            ${isSwift ? "bg-white text-blue-600 shadow-sm" : "text-gray-600 hover:text-gray-800"}
          `}
        >
          SWIFT Code
        </button>

        {/* IBAN */}
        <button
          type="button"
          onClick={() => setIsSwift(false)}
          disabled={isVerified}
          className={`
            flex-1 py-2 text-sm font-semibold rounded-lg transition-all
            ${!isSwift ? "bg-white text-blue-600 shadow-sm" : "text-gray-600 hover:text-gray-800"}
          `}
        >
          IBAN
        </button>
      </div>
    </div>
  );
};

export default SwiftIbanTab;
